module.exports = __webpack_public_path__ + "img/ug344.d4f34983.png";